import SearchBar from '../../../bankAccountsAll/tempComponents/searchBar'
import EditTable from '../../editTable'
import Stack from '@mui/material/Stack'
import TransactionsCsvExport from '../../../../../components/bankAccount/transactions/transactionsCsvExport'
import ToggleFilters from '../../../../../components/tables/tableAccessories/ToggleFilters'
import { useState } from 'react'

const TransactionCounterpartiesTransactionsTable = ({
  originalTableData,
  displayedTableData,
  setDisplayedTableData,
  isLoading,
  onLoadTransactions,
  currentMonth,
  currentYear,
}) => {
  const [resetFilters, setResetFilters] = useState(false)
  const filterReceipts = () => {
    const receiptsOnly = originalTableData.filter((txn) => txn.amount >= 0)
    setDisplayedTableData(receiptsOnly)
  }

  const filterDisbursements = () => {
    const disbOnly = originalTableData.filter((txn) => txn.amount <= 0)
    setDisplayedTableData(disbOnly)
  }

  const filterAll = () => {
    setDisplayedTableData(originalTableData)
  }

  const buttonControls = [
    {
      label: 'Inflows',
      onClick: filterReceipts,
    },
    {
      label: 'Outflows',
      onClick: filterDisbursements,
    },
    {
      label: 'All',
      onClick: filterAll,
    },
  ]

  const onLoadPress = () => {
    onLoadTransactions()
    setResetFilters(true)
  }

  return (
    <Stack spacing={1}>
      <Stack direction='row' spacing={1}>
        <SearchBar
          originalTableData={originalTableData}
          updateTableState={setDisplayedTableData}
          searchKeys={[['counterparty_name'], ['description'], ['timestamp']]}
          isLoading={isLoading}
        />
        <ToggleFilters buttonControls={buttonControls} defaultValue='All' reset={resetFilters} />
        <TransactionsCsvExport transactions={displayedTableData} textWrap='nowrap' height='100%' />
      </Stack>
      <EditTable
        data={displayedTableData}
        pending={false}
        loading={isLoading}
        onLoadTransactions={onLoadPress}
        currentMonth={currentMonth}
        currentYear={currentYear}
      />
    </Stack>
  )
}

export default TransactionCounterpartiesTransactionsTable
